<template>
  <div class="wordcloud-container">
    <div
      class="wordcloud-outer"
      :style="{ width: `${width}px`, minHeight: `${height}px` }"
    >
      <div
        class="wordcloud-inner"
        :style="{
          transformOrigin: '0 0',
          transform: `translate(${transform.x}px,${transform.y}px)scale(${transform.k})`
        }"
      >
        <span
          v-for="d in words.filter(d => d.value.count > 0)"
          :key="d.key"
          class="word"
          :style="{
            fontSize: `${Math.sqrt(d.value.count) * sizeFactor}px`,
            color: color(d.key),
            opacity: opacity(d.key) ? 0.3 : 1,
            cursor: 'pointer'
          }"
          @mouseenter="enterWord(d, $event)"
          @mouseleave="leaveWord(d)"
          @click="$emit('click-word', d)"
        >
          {{ d.key }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { zoom, zoomIdentity } from "d3-zoom";
import { select, event } from "d3-selection";
const getEvent = () => event;

export default {
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    words: {
      type: Array,
      default: () => []
    },
    color: {
      type: Function,
      required: true
    },
    opacity: {
      type: Function,
      required: true
    },
    enableZoom: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    tooltipDelay: 500,
    transform: zoomIdentity,
    timeout: null
  }),
  computed: {
    sizeFactor() {
      return Math.floor(this.width / 72);
    }
  },
  watch: {
    words() {
      this.transform = zoomIdentity;
    },
    enableZoom(value) {
      if (value) {
        select(this.$el)
          .call(this.zoom)
          .call(this.zoom.transform, this.transform);
      } else {
        select(this.$el).on(".zoom", null);
      }
    }
  },
  mounted() {
    this.zoom = zoom().on("zoom", this.zoomed);
    if (this.enableZoom) {
      select(this.$el)
        .call(this.zoom)
        .call(this.zoom.transform, this.transform);
    }
  },
  methods: {
    zoomed() {
      const t = getEvent().transform;
      this.transform = t;
    },
    enterWord(d, event) {
      this.timeout = setTimeout(() => {
        this.$emit("enter-word", d, event);
      }, this.tooltipDelay);
    },
    leaveWord(d) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.$emit("leave-word", d);
    }
  }
};
</script>

<style scoped>
.wordcloud-outer {
  padding: 1rem;
  line-height: 1.1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.wordcloud-inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.word {
  display: inline-block;
  padding: 0 0.25rem;
}
</style>
